import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ScrollDispatcher } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/modules/shared.module';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { UtilsModule } from '@app/modules/utils.module';
import { TranslateModule } from '@ngx-translate/core';
import { CurrentSlipCore } from '@components/current-slip.core';
import { VorabCheckComponent } from '@components/vorab-check.component';
import { BetSettingsComponent } from '@components/bet-settings.component';
import { RouterModule } from '@angular/router';
import { CashoutModule } from '@components/cashout/Cashout.module';
import { RightAreaModule } from '@components/cashout/right-area.module';
import { MaterialImports } from '@environments/environment';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    ZXingScannerModule,
    UtilsModule,
    TranslateModule,
    RouterModule,
    CashoutModule,
    RightAreaModule,
    MaterialImports,
  ],
  declarations: [CurrentSlipCore, VorabCheckComponent, BetSettingsComponent],
  exports: [CurrentSlipCore, VorabCheckComponent, BetSettingsComponent],
  providers: [ScrollDispatcher],
})
export class CurrentSlipModule {}
